export enum AgreementFields {
  MemberAgreedTermsAndConditions = 'memberAgreedTermsAndConditions',
}
